import { defineMessages } from 'react-intl';

export default defineMessages({
  checkbox: {
    id: 'components.Footer.checkbox',
    defaultMessage: 'I agreed and accepted',
  },
  emergency: {
    id: 'components.Footer.emergency',
    defaultMessage: 'EMERGENCY CALL',
  },
  termsAgreementLink: {
    id: 'components.Footer.termsAgreementLink',
    defaultMessage: 'conditions',
  },
});
